import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit, Input, SimpleChanges, Inject, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorPlanProtectionDialogComponent } from '../visualizador-plan-protecion/visualizador-plan-protection-dialog.component';
import { VisualizadorImgDialogComponent } from '../visualizador-img-dialog/visualizador-img-dialog.component';

@Component({
  selector: 'app-historial-servicio-dialog',
  templateUrl: './historial-servicio-dialog.html',
  styleUrls: ['./historial-servicio-dialog.scss']
})

export class HistorialServicioDialogComponent { 

  @ViewChildren('scrollContainer') scrollContainers!: QueryList<ElementRef>;
  banderaInicial = true
  historial = []
  name = ''

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ppService: PlanProtectionService, private dialog: MatDialog, private spinnerService: SpinnerService,
      public dialogRef: MatDialogRef<HistorialServicioDialogComponent>){
    this.historial = data.historial
    this.name = data.name
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  getDate(dateInput: string | Date): string {
    // console.log(dateInput)
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const normalize = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const normalizedDate = normalize(date);
    const normalizedToday = normalize(today);
    const normalizedYesterday = normalize(yesterday);

    if (normalizedDate.getTime() === normalizedToday.getTime()) {
      return 'Hoy';
    } else if (normalizedDate.getTime() === normalizedYesterday.getTime()) {
      return 'Ayer';
    } else {
      return date.toLocaleDateString('es-MX');
    }
  }

  getTime(dateInput: string | Date): string {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    return date.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
  }
  
  scrollLeft(idx) {
    const container = this.scrollContainers.toArray()[idx];
    container.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight(idx) {
    const container = this.scrollContainers.toArray()[idx];
    container.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
  }
  
  abrirImagen(filepaths, i) {
    
    this.dialog.open(VisualizadorImgDialogComponent, {
      // width: '100vw',
      // height: '100vh',z
      data: { imgs: filepaths.filespaths, indexSelected: i },
      panelClass: 'custom-dialog',
    });
  }

}
